import Marketing from "../components/Marketing";
import Feature from "../components/Features";


function Home(){
    return (
      <div>
        <Feature />
        <Marketing />
      </div>
    );
}
export default Home;